import { render, staticRenderFns } from "./Devices3.vue?vue&type=template&id=63271b2a"
import script from "./Devices3.vue?vue&type=script&lang=js"
export * from "./Devices3.vue?vue&type=script&lang=js"
import style0 from "./Devices3.vue?vue&type=style&index=0&id=63271b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports